import {
    ActionIdentifiers,
    ActionsActionTypes,
    ActionsState,
} from "#store/actions/actionTypes";
import { ErrorState, IoState, IoStateEnum } from "#store/types";
import { Action } from "#services/pilotService/types";

const initialState: ActionsState = {
    actions: {},
};

// The reducer function
export function actionsReducer(
    state = initialState,
    action: ActionsActionTypes
): ActionsState {
    switch (action.type) {
        case ActionIdentifiers.PUT_QUERY_FAILED: {
            return {
                ...state,
                [action.payload.id]: {
                    state: IoStateEnum.error,
                    payload: null,
                    error: action.payload.error,
                    timestamp: new Date(),
                } as ErrorState,
            };
        }
        case ActionIdentifiers.PUT_QUERY_STARTED: {
            const newKey = action.payload;
            return {
                ...state,
                actions: {
                    ...state.actions,
                    [newKey]: {
                        state: IoStateEnum.fetching,
                        payload: null,
                        timestamp: new Date(),
                        error: null,
                    },
                },
            };
        }
        case ActionIdentifiers.FETCH_ACTION_STARTED: {
            const newKey = action.payload;
            return {
                ...state,
                actions: {
                    ...state.actions,
                    [newKey]: {
                        state: IoStateEnum.fetching,
                        payload: null,
                        timestamp: new Date(),
                        error: null,
                    },
                },
            };
        }
        case ActionIdentifiers.FETCHED_LIST_FROM_SERVER: {
            const mapToObjects: Array<[number, IoState<Action>]> =
                action.payload.map(x => {
                    return [
                        x.id,
                        {
                            payload: x,
                            state: IoStateEnum.done,
                            timestamp: new Date(),
                            error: null,
                        },
                    ];
                });

            return {
                ...state,
                actions: {
                    ...state.actions,
                    ...Object.fromEntries(mapToObjects),
                },
            };
        }
        case ActionIdentifiers.PUT_QUERY_SUCCEEDED:
        case ActionIdentifiers.FETCH_ACTION_SUCCEEDED: {
            const newKey = action.payload.id;
            return {
                ...state,
                actions: {
                    ...state.actions,
                    [newKey]: {
                        state: IoStateEnum.done,
                        payload: action.payload,
                        timestamp: new Date(),
                        error: null,
                    },
                },
            };
        }
        case ActionIdentifiers.FETCH_ACTION_FAILED: {
            const key = action.payload.id;
            return {
                ...state,
                actions: {
                    ...state.actions,
                    [key]: {
                        state: "error",
                        error: action.payload,
                        timestamp: new Date(),
                        payload: null,
                    },
                },
            };
        }
        default: {
            return state;
        }
    }
}
